import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const KivraSymbol: Illustration = (props) => (
  <svg viewBox="0 0 80 80" {...illustrationProps(props, { width: 80 })}>
    <path
      fill="#76C82E"
      d="M0 40.5C0 7.56 7.06.5 40 .5s40 7.06 40 40-7.06 40-40 40-40-7.06-40-40"
    />
    <path
      fill="#fff"
      d="m44.825 45.064-3.534-7.62L52.485 24.75h-7.029L32.87 39.336V24.75h-5.82v31.325h5.82v-9.07l4.335-4.914 2.699 5.792c2.33 4.967 5.51 8.367 10.524 8.367.806 0 1.791-.087 2.51-.267v-5.01s-.626.135-1.476.135c-3.184-.005-4.752-1.974-6.636-6.044"
    />
  </svg>
);
